const getOptionForMultiselectOrdersMenu = (t) => [
    {
        id: 'o1',
        name: {
            en: 'Created',
            ru: '',
            ge: ''
        },
    },
    {
        id: 'o2',
        name: {
            en: 'Completed',
            ru: '',
            ge: ''
        },
    },
    {
        id: 'o3',
        name: {
            en: 'Rejected',
            ru: '',
            ge: ''
        },
    },
    {
        id: 'o4',
        name: {
            en: 'Declined',
            ru: '',
            ge: ''
        },
    },
    {
        id: 'o5',
        name: {
            en: 'Other',
            ru: '',
            ge: ''
        },
    },
]

export {
    getOptionForMultiselectOrdersMenu
}